import * as React from 'react';

function SvgHelpFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 17A8 8 0 109 1a8 8 0 000 16zm.922-6.64c-.096.203-.14.566-.13 1.088H8.095a38.5 38.5 0 01-.007-.453c0-.558.091-1.017.273-1.377.182-.36.546-.765 1.091-1.216.546-.45.872-.745.979-.884.164-.22.246-.464.246-.73 0-.368-.146-.685-.436-.948-.29-.263-.682-.395-1.174-.395-.475 0-.872.137-1.192.412-.319.274-.538.693-.658 1.256L5.5 6.897c.049-.806.387-1.49 1.015-2.053C7.142 4.281 7.966 4 8.987 4c1.073 0 1.927.285 2.562.854.634.57.951 1.232.951 1.989 0 .418-.116.814-.35 1.188-.232.374-.73.882-1.493 1.526-.395.333-.64.601-.735.804zm.043 1.743V14h-1.87v-1.897h1.87z"
        fill="#8D8D8D"
      />
    </svg>
  );
}

export default SvgHelpFilled;
